export default __webpack_public_path__ + "static/media/visa.a9591eb2.svg";